module.exports = __webpack_public_path__ + "media/images/icon-checkbox-check-60b7f1946e6073fe7f2654aa48c6041d.svg";